<template>
  <div>
    <flexbox class="py-2" style="background-color: #FFFFFF" :gutter="0">
      <flexbox-item class="text-left" :span="10" @click.native="onSelected">
        <flexbox orient="vertical">       
          <flexbox-item class="text-left pl-3">{{address.name}}, {{address.mobile}}</flexbox-item>
          <flexbox-item class="px-3">{{address.province}} {{address.city}} {{address.district}} {{address.detail}}</flexbox-item>
        </flexbox>
      </flexbox-item>
      <flexbox-item class="text-left px-3" :span="2" @click.native="editAddress(address)">
        <i class="fa fa-edit"></i>  
      </flexbox-item>
    </flexbox>  
  </div>
</template>
<script type="text/javascript">

import { mapGetters } from 'vuex'
import { Flexbox, FlexboxItem, Cell, CheckIcon } from 'vux'


export default {
  name: 'AddressItem',
  components: {
    Flexbox, 
    FlexboxItem,
    Cell,
    CheckIcon
  },
  props: {
    address: Object
  },
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {},
  watch: {},
  computed: {
    priceStr(){
      return this.$t('kol.priceUnit') + ' ' + this.price;
    }
  },
  methods: {
    editAddress(address){

      var addressCopy = Object.assign({}, address);

      console.log('hello');

      this.$router.push({
        name:'Address Create',
        params:{
          addressInput: addressCopy,
          edit: true
        }
      });      
    },
    onSelected(address){
      this.$emit('onAddressSelected');
    }
  },
}

</script>
<style type="text/css">
.headerContainer{
/*  margin-top: 44px;
*/}
</style>




// WEBPACK FOOTER //
// src/Cart/components/AddressItem.vue